import { useRoutes } from "react-router-dom";
import RouteMap from "./app/config/routeConfig";
import { getSubdomain } from "app/utils/generic.helper";

// import "theme/index.scss";

const Entry = () => {
  const domain = getSubdomain();
  const queryParams = new URLSearchParams(window.location.search);
  const tokenParam: any = queryParams.get("token");
  
  // Set token synchronously before render (bypass auth for demo)
  // Don't redirect here - let ProtectedRoute handle routing
  if (domain !== "integration") {
    if (!localStorage.getItem("token")) {
      localStorage.setItem("token", "demo-token-vcc");
    }
  } else if (domain === "integration") {
    localStorage.clear();
    if (tokenParam) {
      localStorage.setItem("token", tokenParam);
    }
  }

  const routes = useRoutes([...RouteMap]);
  return routes;
};

export default Entry;
